import { cancelUserCollect, hasCollection, insertUserCollect } from '@/api/collect.js'
import { getMallAppToken } from '@/utils/globalData.js'

import { ElMessage } from 'element-plus'
import { ref } from 'vue'
import { useMainStore } from './store.js'


export function useCollect(itemId) {
  const hasCollect = ref(false)

  async function addToCollect() {
    const userInfo = useMainStore().mallUserInfo
    const userId = userInfo.id
    const res = await insertUserCollect({
      userId,
      itemId,
      source: 4,
    })
    if (res.success) {
      ElMessage({
        message:$t('messages.collectSuccess') ,
        type: 'success',
        plain: true,
      })
      hasCollect.value = true
    }
  }

  if(process.client&&(getMallAppToken())){
    queryHasCollect()
  } 

  async function cancelCollect() {
    const userInfo = useMainStore().userInfo
    const userId = userInfo.id
    const res = await cancelUserCollect({
      userId,
      itemId,
      source: 4,
    })
    if (res.success) {
      ElMessage({
        message:$t('messages.cancelCollectSuccess') ,
        type: 'success',
        plain: true,
      })
      hasCollect.value = false
    }
  }

  async function queryHasCollect() {
    const res = await hasCollection({
      itemId,
      source: 4,
    })
    hasCollect.value = res.data > 0
  }

  return {
    hasCollect,
    addToCollect,
    cancelCollect,
    queryHasCollect,
  }
}
